module.exports = __webpack_public_path__ + "img/01.prt.e4fc93eb.jpg";